export class BucketBrowserPage {
  index: number = -1;
  id: string = '';
  available: boolean = true;
  label: string = '';
  storagePath: string = '';

  constructor(id: string, label: string) {
    this.id = id;
    this.label = label;
  }
}